import ReactECharts from "echarts-for-react";
import { SubscriptionStatusMetric } from "@/services/metrics";
import { Loader2 } from "lucide-react";

interface SubscriptionStatusChartProps {
  data: SubscriptionStatusMetric[];
  isLoading: boolean;
}

export function SubscriptionStatusChart({ data, isLoading }: SubscriptionStatusChartProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[300px]">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-[300px] text-muted-foreground text-sm">
        Sin datos para el período seleccionado
      </div>
    );
  }

  // Use the latest snapshot
  const latest = data[data.length - 1];
  const healthRate = parseFloat(latest.healthRate || "0").toFixed(1);
  const total = latest.totalCount || 0;

  const pieData = [
    { value: latest.activeCount, name: "Activas", itemStyle: { color: "#22C55E" } },
    { value: latest.expiring_7DaysCount, name: "Vence en 7d", itemStyle: { color: "#F59E0B" } },
    { value: latest.expiring_3DaysCount, name: "Vence en 3d", itemStyle: { color: "#FB923C" } },
    { value: latest.expiredCount, name: "Vencidas", itemStyle: { color: "#EF4444" } },
    { value: latest.cancelledCount, name: "Canceladas", itemStyle: { color: "#94a3b8" } },
  ].filter((d) => d.value > 0);

  const option = {
    tooltip: {
      trigger: "item",
      backgroundColor: "#fff",
      borderColor: "#e2e8f0",
      borderWidth: 1,
      textStyle: { color: "#1e293b", fontSize: 12 },
      formatter: (params) =>
        `<div style="font-weight:600">${params.name}</div>
         <div>${params.value} <span style="color:#64748b">(${params.percent}%)</span></div>`,
    },
    legend: {
      orient: "horizontal",
      bottom: 0,
      textStyle: { color: "#64748b", fontSize: 10 },
      icon: "circle",
      itemWidth: 8,
      itemHeight: 8,
    },
    graphic: [
      {
        type: "text",
        left: "center",
        top: "36%",
        style: {
          text: `${healthRate}%`,
          fill: "#1e293b",
          fontSize: 22,
          fontWeight: "700",
          fontFamily: "Inter, sans-serif",
        },
      },
      {
        type: "text",
        left: "center",
        top: "50%",
        style: {
          text: `${total} total`,
          fill: "#94a3b8",
          fontSize: 11,
          fontFamily: "Inter, sans-serif",
        },
      },
    ],
    series: [
      {
        name: "Estado",
        type: "pie",
        radius: ["48%", "70%"],
        center: ["50%", "45%"],
        avoidLabelOverlap: false,
        label: { show: false },
        labelLine: { show: false },
        emphasis: {
          scale: true,
          scaleSize: 6,
          label: { show: false },
        },
        data: pieData,
      },
    ],
  };

  return <ReactECharts option={option} style={{ height: 300 }} opts={{ renderer: "svg" }} />;
}
